<template>

    <div class="formSection">

        <div class="row form-group">
            <div class="col-12">
                <h4>
                    <label>{{$t('transactions.textPeriodClose')}}</label>
                </h4>
            </div>
        </div>
        <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>
        <hr>
        <div class="row form-group">
            <div class="col col-4 extensionLine">
                <label for="expensePrice" class=" form-control-label">{{$t('transactions.price')}} ({{prefix}}{{suffix}})</label>
            </div>
            <div class="col col-8">
                <InputText id="expensePrice" name="expensePrice" v-model="expensePrice" v-validate="'numeric'" hasToKeyboard="auto" value="" :title="$t('transactions.price')" placeholder="..." dataLayout="nn"
                           className="form-control mandatory" :hasError="errors.has('expensePrice')"/>
                <small class="unit form-text text-muted d-none "></small>
            </div>
        </div>

        <div class="row form-group">
            <div class="col col-4 extensionLine">
                <label for="expenseText" class=" form-control-label">{{$t('transactions.text')}}</label>
            </div>
            <div class="col col-8">
                <InputText id="expenseText" name="expenseText" v-model="expenseText" v-validate="'required'" hasToKeyboard="auto" value="" :title="$t('transactions.text')" placeholder="..." dataLayout="t"
                           className="form-control mandatory" :hasError="errors.has('expenseText')" />
                <small class="unit form-text text-muted d-none"></small>
            </div>
        </div>
        <div class="row form-group">
            <div class="col col-4 extensionLine">
                <label for="expenseDay" class=" form-control-label">{{$t('transactions.date')}}</label>
            </div>
            <div class="col col-8">
                <div class="row ">
                    <div class="col col-12 dateSelectsContainer">
                        <div class="colcol-4">
                            <select id="expenseYear" v-model="expenseYear" class="form-control" name="expenseYear">
                                <option v-for="monthOption in expenseYearOptions" :value="monthOption.value">{{monthOption.text}}</option>
                            </select>
                        </div>
                        <div class="colcol-4">
                            <select id="expenseMonth" v-model="expenseMonth" class="form-control" name="expenseMonth">
                                <option value="1">{{$t('global.monthNames.January')}}</option>
                                <option value="2">{{$t('global.monthNames.February')}}</option>
                                <option value="3">{{$t('global.monthNames.March')}}</option>
                                <option value="4">{{$t('global.monthNames.April')}}</option>
                                <option value="5">{{$t('global.monthNames.May')}}</option>
                                <option value="6">{{$t('global.monthNames.June')}}</option>
                                <option value="7">{{$t('global.monthNames.July')}}</option>
                                <option value="8">{{$t('global.monthNames.August')}}</option>
                                <option value="9">{{$t('global.monthNames.September')}}</option>
                                <option value="10">{{$t('global.monthNames.October')}}</option>
                                <option value="11">{{$t('global.monthNames.November')}}</option>
                                <option value="12">{{$t('global.monthNames.December')}}</option>
                            </select>
                        </div>
                        <div class="colcol-4">
                            <select id="expenseDay" v-model="expenseDay" class="form-control" name="expenseDay">
                                <option v-for="monthOption in expenseDayOptions" :value="monthOption.value">{{monthOption.text}}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row form-group">
            <div class="col col-4 ">
            </div>
            <div class="col col-8">
                <button v-on:click="expenseSave()" type="button" class="btn btn-success btn-lgX btn-expense">
                    <i class="fa fa-dot-circle-o"></i> {{$t('transactions.save')}}
                </button>
            </div>
        </div>
    </div>

</template>


<script>
    import LngChooser from '@/components/LngChooser.vue';
    import AlertInPage from '@/components/AlertInPage.vue';
    import Helper from '@/helper/Helper';
    import InputText from '@/components/InputText.vue';
    import SellHeader from "../components/SellHeader";
    import moment from 'moment';
    import Api from '@/api/Api';

    export default {
        name: 'TransactionsCloseingBalance',
        data() {
            return {
                prefix: "",
                suffix: "",
                expensePrice: "",
                expenseText: "",
                expenseYear: "",
                expenseYearOptions: [],
                expenseMonth: "",
                expenseDay: "",
                expenseDayOptions: [],
                AlertInPage: {
                    type: "", // primary secondary success danger warning info light dark
                    msg: "",
                    delay: 5000,
                }
            };
        },
        watch: {
        },
        mounted() {
            const modul = this;
            modul.setYearsMonths();
            console.log(this.$route.name + " mounded");
            modul.prefix = Helper.getMoneyDefaultDisplayPrefix();
            modul.suffix = Helper.getMoneyDefaultDisplaySuffix();
        },
        methods: {
            cb: function (err, res) {
                const modul = this;
                if (err) {
                    modul.AlertInPage.msg = "global.error";
                    modul.AlertInPage.type = "danger";
                    setTimeout(function (e) {
                        modul.AlertInPage.msg = "";
                    }, Number(5000));
                } else {
                    modul.expensePrice = "";
                    modul.expenseText = "";
                    modul.AlertInPage.msg = "global.success";
                    modul.AlertInPage.type = "success";
                    setTimeout(function (e) {
                        modul.AlertInPage.msg = "";
                    }, Number(1000));
                }
                setTimeout(function () {
//                    SyncHandler.handle({job: 'doSell'});
                }, 1);
            },
            expenseSave: function () {
                const modul = this;
                modul.save(modul.cb, "expense");
            },
            setYearsMonths(){
                const modul = this;
                const actualYears = [moment().get("year"), moment.utc().get("year") - 1, moment.utc().get("year") - 2];
                const actualMonth = moment().get("month") + 1;
                const actualDay = moment().format('D');
                const yearOptions = [];
                Array.prototype.forEach.call(actualYears, function (e) {
                    yearOptions.push({'value': e, 'text': e});
                });
                const dayOptions = [];
                for (let e = 1; e <= 31; e++) {
                    dayOptions.push({'value': e, 'text': e});
                }
                const selectedYear = "" + actualYears[0];
                const selectedMonth = "" + actualMonth;
                const selectedDay = "" + actualDay;

                modul.expenseYearOptions = yearOptions;
                modul.expenseDayOptions = dayOptions;
                modul.expenseYear = selectedYear;
                modul.expenseMonth = selectedMonth;
                modul.expenseDay = selectedDay;
            },
            save(cb, type){
                const modul = this;
                modul.$validator.validateAll().then((result) => {
                    if (result) {
                        const data = {id: null}; // dbh.getRow("sell"); //
                        if (type === "expense") {
                            data.transferreason = 7;
                            data.sum = modul.expensePrice;
                            data.selltext = modul.expenseText;
                            data.wsid = Helper.machineIdSync();
                            if (typeof Number(data.sum) === "NaN") {
                                data.sum = 0;
                            }
                            if (Number(data.sum) > 0) {
                                data.sum = "-" + data.sum;
                            }
                            const strDate = moment.utc(modul.expenseYear + "-" + modul.expenseMonth + "-" + modul.expenseDay, "YYYY-MM-DD");
                            data.datetime = strDate.format('YYYY-MM-DD 00:00:00');
                        } else {
                            return;
                        }
                        if (window && window.user && window.user.id) {
                            data.id_adminuser = window.user.id;
                        }
                        if (window && window.user && window.user.sync_pk) {
                            data.sync_pk_adminuser = window.user.sync_pk;
                        }
                        data.selltype = 0;
                        data.status = 1;
                      Api.addTransaction({data: data}).then(function (e) {
                        if (e && e.result === true) {
                          console.log(e)
                          if (typeof cb === "function") {
                            cb(null, e.data);
                          }
                        }
                      }, function (err) {
                        if (typeof cb === "function") {
                          cb(err, null);
                        }
                      });

                    } else {
                        // form validate error
                        modul.AlertInPage.msg = "global.saveError";
                        modul.AlertInPage.type = "danger";
                        setTimeout(function (e) {
                            modul.AlertInPage.msg = "";
                        }, Number(5000));
                    }
                });
            },
        },
        components: {
            SellHeader,
            InputText,
            LngChooser,
            AlertInPage,

        },
    };
</script>

